import React, { useState } from 'react'
import DetailsCard from '../components/DetailsCard';
import Modal from '../components/modals/Modal';
import CODModal from '../components/modals/CODModal';
import { cod } from '../data/correctionOfData'
import DashboardLayout from './DashboardLayout';



const Help3 = () => {
  const [modal, setModal] = useState(false);
  const [data, setData] = useState([])

  const handleCard = (item) => {
    setModal(true)
    setData(item)
    // console.log(item.content,'DATA');
  }

  return (
    <DashboardLayout help="Application for correction of data" childTab={13} animated={true}>
    <div className='flex flex-col items-center justify-center w-full px-5 pb-7 mt-10 md:px-6 md:mt-5 lg:relative lg:px-7 lg:mt-3 xl:px-10 xl:pb-10'>

        {/*SYLLABUS CARDS*/}
        <div className='flex items-center justify-between w-full flex-wrap mt-6 md:justify-start'>
            {cod.map((item) => {
              return(
                <DetailsCard onClick={()=>handleCard(item)} key={item.id} data={item} index={item.id} />
              )
            })}
        </div>


             {/*MODALS*/}
         {modal &&
          <Modal onClick={()=>setModal(false)}>
               <CODModal data={data} setModal={setModal} />
          </Modal>
          }

    </div>
    </DashboardLayout>
  )
}

export default Help3
